<template>
  <ElDialog
    :visible="value"
    width="25%"
    class="stats-announcement-modal"
    :show-close="false"
    append-to-body
    @close="emitInputEvent"
  >
    <p class="stats-announcement-modal__title">
      {{ $t(title) }}
    </p>
    <div
      v-dompurify-html="$t(text)"
      class="stats-announcement-modal__description-container"
    />
    <div class="stats-announcement-modal__action-container">
      <ElButton
        class="stats-announcement-modal__action"
        type="text"
        @click="emitInputEvent"
      >
        {{ $t('APP.STATS.ANNOUNCEMENT_SUBMIT') }}
      </ElButton>
    </div>
  </ElDialog>
</template>
<script>
export default {
  name: 'StatsAnnouncementModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  methods: {
    emitInputEvent() {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss">
.stats-announcement-modal {
  text-align: center;

  @include breakpoint(small down) {
    display: flex;
    align-items: center;
    justify-content: center;

    .el-dialog {
      margin: 0 !important;
    }
  }

  .el-dialog__body {
    padding: 0;
  }

  &__title {
    font-weight: bold;
  }

  &__description-container {
    padding: 0 $global-margin;
    margin-bottom: $global-margin * 2;
  }

  &__action-container {
    border-top: 0.25px solid $lb-color-primary;
  }

  &__action {
    width: 100%;
    height: 100%;
    border-radius: 0;

    &:hover {
      background-color: $lb-color-primary !important;
      color: $lb-white !important;
    }

    &:focus {
      background-color: transparent !important;
      color: $lb-color-primary !important;
    }
  }
}
</style>
